module.exports = __webpack_public_path__ + "static/media/tableNav_black.97a69639.svg";